/**
 * Детектор Android (TV / Fully Kiosk / WebView).
 * На этих устройствах HTML5 video + UI-анимации часто делят один GPU/декодер.
 */
export const isAndroidTabloDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent || '');
};

/** @deprecated use isAndroidTabloDevice */
export const isAndroidWebViewTablo = isAndroidTabloDevice;

export const isWeakAndroidTabloWebView = isAndroidTabloDevice;
